import { BuildingRightsType } from "by/gamefactory/cityversetycoon/networking/data/responses/user/BuildingRightsType";
import { Container, Text, TextStyle } from "pixi.js";
import { BuildingRankUpTextComponentsTextStyle } from "./BuildingRankUpTextComponentsTextStyle";
import { GameFont } from "../../../common/GameFont";

export class BuildingRankUpBottomTextComponent extends Container {
    private static readonly LANDLORD_TEXT = 'All your renters will share\nthe reward amount';
    private static readonly RENTER_TEXT = 'Keep upgrading to earn OWN Points and other rewards\nto become an owner and earn all OWN Points for yourself!';
    private readonly text: Text;

    public constructor(role: BuildingRightsType) {
        super();
        let properText: string;
        let textStyle: TextStyle;
        switch (role) {
            case BuildingRightsType.OWNER:
            case BuildingRightsType.LANDLORD: {
                properText = BuildingRankUpBottomTextComponent.LANDLORD_TEXT;
                textStyle = new BuildingRankUpTextComponentsTextStyle();
                break;
            }
            case BuildingRightsType.RENTER: {
                properText = BuildingRankUpBottomTextComponent.RENTER_TEXT;
                textStyle = new BuildingRankUpRenterTextComponentTextStyle()
                break;
            }
        }
        this.text = new Text(properText, textStyle);
        this.addChild(this.text);
    }
}

class BuildingRankUpRenterTextComponentTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.Bebasneuepro_Smerg,
            fontSize: 36,
            align: 'left',
            fill: '#FFFFFF'
        });
    }
}